"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
class SubscriptionHandler {
    constructor() {
        this.subscriptions = [];
    }
    start(callback, delay = 0) {
        let subscription;
        if (callback instanceof Function && delay > 0) {
            subscription = (0, rxjs_1.timer)(delay).subscribe(callback);
        }
        else if (callback instanceof rxjs_1.Subscription) {
            subscription = callback;
        }
        else {
            throw new Error('Immediate functions have to be called directly and not by SubscriptionHandler');
        }
        this.subscriptions.push(subscription);
        return subscription;
    }
    stop() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.subscriptions = [];
    }
}
exports.default = SubscriptionHandler;
//# sourceMappingURL=SubscriptionHandler.js.map